module.exports = __webpack_public_path__ + "img/Gallery_2_39.562a7335.jpeg";